import { env } from '../env';
/**
 * cookie name must be only lowercase and _
 */
export const COOKIE_KEY_MEMBER_KNOWN = 'known';

/**
 * Cookies used by toolbar with a specific name : same as EBC
 */
export const COOKIE_KEY_USERNAME = env.REACT_APP_COOKIE_PREFIX + 'Pseudo';
export const COOKIE_KEY_ID = env.REACT_APP_COOKIE_PREFIX + 'ID';
export const COOKIE_KEY_ACCESS = env.REACT_APP_COOKIE_PREFIX + 'Access';

export const COOKIE_KEY_REDIRECT_AFTER_LOGIN = 'redirectAfterLogin';



// WEBPACK FOOTER //
// ./src/constants/cookie.js